(function () {
    'use strict';

    angular.module('app.shared.directives').filter('asaCurrency', ['staticData',
        function (staticData) {
            return function (num, currencyKey, overrideDecimals, showSymbol) {  // overrideDecimals = bool, default is false = show as intended in currency table, true = don't show decimals
                if (num == null || currencyKey == null || currencyKey == '') {                       // showSymbol = bool, default is true
                    return '';
                }
                var negative;
                if (num < 0) {
                    num = Math.abs(num);
                    negative = true;
                }
                var match;
                //if (currencyKey === null) {
                //    var companies = staticData.get("companies");
                //    var user = sessionService.getCurrentUser();
                //    match = companies.find(function (o) { return o.currencyKey == user.currencyKey }); 
                //}

                if (Number.isInteger(currencyKey) && currencyKey >= 0) {
                    var currencies = staticData.get("currencies");
                    if (currencies == null) { return num };
                    match = currencies.find(function (o) { return o.CurrencyKey == currencyKey })
                    if (match == null)
                        return;
                } else {
                    return;
                }
                var digitsAfterDecimal = match.DigitsAfterDecimal;
                var numString = parseFloat(num.toString()).toFixed(digitsAfterDecimal);

                var currencySymbol = match.CurrencySymbol;
                var currencySymbolPos = match.CurrencySymbolPos;
                var groupSymbol = match.GroupSymbol;
                var digitsInGroup = match.DigitsInGroup;
                var decimalSymbol = match.DecimalSymbol;
                var groupedNum = '', finalNum = '';
                var zero = '0';
                var parts = numString.split('.');
                var wholeNumber = parts[0];
                var decimals;
                if (parts[1] != null) {
                    decimals = decimalSymbol + parts[1].slice(0, digitsAfterDecimal);
                    if (decimals.length <= digitsAfterDecimal) {
                        decimals += zero.repeat((digitsAfterDecimal + 1) - decimals.length);
                    }
                } else {
                    decimals = decimalSymbol + zero.repeat(digitsAfterDecimal);
                }

                var divisor = math.ceil(wholeNumber.length / digitsInGroup);
                var i = 1, j = 0, listOfGroups = [];
                while (i <= divisor) {
                    var group = wholeNumber.slice(Math.max((wholeNumber.length - (i * digitsInGroup)), 0), wholeNumber.length - (j * digitsInGroup));
                    listOfGroups.push(group);
                    i++;
                    j++;
                }
                for (var k = listOfGroups.length - 1; k >= 0; k--) {
                    groupedNum += listOfGroups[k] + groupSymbol;
                }
                
                if (digitsAfterDecimal == 0 || overrideDecimals == true) { // don't show decimals  
                    finalNum = groupedNum.slice(0, -1)
                } else if (overrideDecimals == false || overrideDecimals == null) { // show decimals
                    finalNum = groupedNum.slice(0, -1) + decimals;
                }

                if (showSymbol == false) {
                    finalNum = finalNum;
                } else if ((showSymbol == true || showSymbol == null) && (currencySymbolPos == "Before" || currencySymbolPos == "before")) {
                    finalNum = currencySymbol + finalNum;
                } else if ((showSymbol == true || showSymbol == null) && (currencySymbolPos == "After" || currencySymbolPos == "after")) {
                    finalNum = finalNum + currencySymbol;
                }

                if (negative == true) {
                    finalNum = "(" + finalNum + ")";
                }

                return finalNum;
            };
        }
    ]);

	angular.module('app.shared.directives').directive('asaRequestFocus', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					scope.$watch(attrs.asaRequestFocus, function (value) {
						if (value === true) {
							$(element).prop('disabled', false);
							element[0].focus();
							//scope[attrs.asaRequestFocus] = false; // XXXX toggle to false not working? (because not 2way bind)
						}
					});
				}
			};
		}
	]);

	// You would use this directive if this directive runs before the element is actually focusable
	// This Is being used in asaModal.html
	angular.module('app.shared.directives').directive('asaAddAutofocus', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					scope.$watch(attrs.asaAddAutofocus, function (value) {
						if (value === true) {
							$(element).attr('autofocus', "");
						}
					});
				}
			};
		}
	]);

	//autoselect text
	angular.module('app.shared.directives').directive('asaAutoSelectText', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					element.on('focus', function () {
						this.select();
					});
				}
			};
		}
	]);


	angular.module('app.shared.directives').directive('asaStopFocusScroll', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					element.on('focus', function (event) {
						var x = $(event.target).parents('.floatThead-table').first().parent().scrollLeft();
						if (x != null) {
							$(event.target).parents('.floatThead-table').first().parent().next().scrollLeft(x);
						}
					});
				}
			};
		}
	]);

	// sets up 2-way binding and automatically sets the obj.value to false 
	// don't have to manually toggle to false in the controller. needs to be an object instead of bool for 2-way binding
	angular.module('app.shared.directives').directive('asaRequestFocusObj', [
		function () {
			return {
				restrict: 'A',
				scope: {
					trigger: '=asaRequestFocusObj'
				},
				link: function (scope, element, attrs) {
					element.on('focus', function () {
						scope.trigger.value = false;
					});

					scope.$watch('trigger.value', function (newVal) {
						if (newVal === true) {
							$(element).prop('disabled', false);
							element[0].focus();
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaEnterKeyPressed', [
		function () {
			return {
				link: function (scope, element, attrs) {
					element.bind("keydown keypress", function (event) {
						if (event.which === 13) {
							scope.$apply(function () {
								scope.$eval(attrs.asaEnterKeyPressed);
							});
							event.preventDefault();
							event.stopPropagation();
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaEnterKeyBlur', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element) {
					element.bind("keydown keypress", function (event) {
						if (event.which === 13) {
							event.target.blur();
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('tooltip', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					$(element).hover(function () {
						// on mouseenter
						$(element).tooltip('show');
					}, function () {
						// on mouseleave
						$(element).tooltip('hide');
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaCollapsePanel', [
		function () {
			return {
				restrict: 'E',
				transclude: true,
				replace: true,
				scope: {
					panelId: '@',
					caption: '@',
					glyphIcon: '@',
					expanded: '@',
					headerStyle: '@',
					buttonText: '@',
					buttonCallback: '<'
				},
				templateUrl: '/shared/directives/asaCollapsePanel.html'
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaPanel', [
		function () {
			return {
				restrict: 'E',
				transclude: true,
				replace: true,
				scope: {
					caption: '@',
					glyphIcon: '@',
				},
				templateUrl: '/shared/directives/asaPanel.html'
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaCheckbox', [
		function () {
			return {
				restrict: 'E',
				replace: true,
				scope: {
					caption: '@',
					asaModel: '=',
					labelClass: '@'
				},
				templateUrl: '/shared/directives/asaCheckbox.html'
			};
		}
	]);

	angular.module('app.shared.directives').directive('money', [
		function () {
			return {
				restrict: 'A',
				require: '?ngModel',
				link: function (scope, element, attrs, ngModelCtrl) {
					if (!ngModelCtrl) {
						return;
					}

					ngModelCtrl.$parsers.push(function (val) {
						var clean = val.replace(/[^0-9]+/g, '');
						if (val !== clean) {
							ngModelCtrl.$setViewValue(clean);
							ngModelCtrl.$render();
						}
						return clean;
					});

					element.bind('keypress',
						function (event) {
							if (event.keyCode === 32) {
								event.preventDefault();
							}
						});
				}
			};
		}
	]);

	// when using ng-include in index.html to include a shell page
	// the shell page's ng-view won't work correctly on the initial
	// load unless ng-view is surrounded by this directive
	// <div asa-ng-view-fix><div ng-view></div></div>
	angular.module('app.shared.directives').directive('asaNgViewFix', ['$route',
		function ($route) {
			return {
				link: function () {
					//$route.reload();
				}
			};
		}
	]);

	//Localize Strings
	angular.module("app.shared.directives").directive("asaLabel", ["localizationService",
		function (localizationService) {
			return {
				restrict: "E",
				scope: {
					stringno: "=",
					defaultText: "@",
					bustAutoFill: "=?"
				},
				replace: true,
				template: "<label class='aSaLabel'>{{stringText}}</label>",
				controller: ["$scope", function ($scope) {
					var tempString = null;
					if ($scope.stringno == null) { tempString = $scope.defaultText || ""; }
					else {
						tempString = localizationService.getLocalString($scope.stringno);
						if ($scope.bustAutoFill) {
							var stringChars = [];
							for (var i = 0; i < tempString.length; i++) {
								stringChars.push(tempString.charAt(i));
							}
							tempString = stringChars.join("\u2063");
						}
					}
					$scope.stringText = tempString;
				}],
				controllerAs: "vm"
			};
		}
	]);


	angular.module("app.shared.directives").directive("ignoreDirty", [function () {
		return {
			restrict: "A",
			require: "ngModel",
			link: function (scope, elm, attrs, ctrl) {
				ctrl.$setPristine = function () { };
				ctrl.$pristine = false;
			}
		};
	}]);

	//used in Environment setup and System manager
	angular.module('app.shared.directives').directive('unique', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var duplicates = scope.$eval(attrs.unique) || [];
						var model = angular.lowercase(scope.$eval(attrs.ngModel));
						var key = scope.$eval(attrs.uniquekey);
						var property = attrs.uniqueproperty;
						var count = 0;
						for (var i = 0; i < duplicates.length; i++) {
							if (angular.lowercase(duplicates[i][attrs.name]) === model && duplicates[i][property] !== key && !duplicates[i].Metadata.IsDeleted) {
								if (angular.lowercase(duplicates[i][attrs.name]) != null && model != null) {
									count++;
								}
							}
						}
						if (count > 0) {
							ctrl.$setValidity('unique', false);
							return viewValue;
						} else {
							ctrl.$setValidity('unique', true);
							return undefined;
						}
					});
				}
			};
		}
	]);

	// Uniqueness Validation for aSa-Grid cells
	// *** To check uniqueness for multiple cells, my-property must be an array of strings that contain the characteristics that all must be unique ***
	// *** The array must be declared in the controller. For example: HTML --> my-property={{vm.array}}  Controller --> vm.array = ['ID', 'Descr']; ***
	angular.module('app.shared.directives').directive('asaUnique', [
		function () {
			return {
				restrict: 'A',
				require: ['ngModel', '^asaGrid'],
				link: function (scope, elm, attrs, controllers) {
					if (elm[0].tagName == "TD") return;
					scope.$watch(attrs.ngModel, function (viewValue) {
						var ngModel = controllers[0];
						var gridController = controllers[1];

						var model = angular.lowercase(scope.$eval(attrs.ngModel));
						var fullCollection = gridController.scope.getItems();

						// filter out Metadata.IsDeleted === true
						var collection = fullCollection.filter(function (item) {
							return (item.Metadata == null || item.Metadata.IsDeleted !== true);
						});


						var model = [];
						var key = parseInt(attrs.uniquekey);
						var property = attrs.uniqueproperty;
						var myProperty = scope.$eval(attrs.myProperty);

						// If the property is not an array, it will not evaluate it and turn myProperty to null
						if (myProperty == null) myProperty = [attrs.myProperty];
						// This is done for speed's sake. If there is only 1 property to match on, it won't go through and find it with the loop
						if (myProperty.length > 0) {
							for (var i = 0; i < collection.length; i++) {
								if (collection[i][property] == key) {
									for (var j = 0; j < myProperty.length; j++)
										model.push(collection[i][myProperty[j]]);
								}
							}
						}
						else {
							model = [angular.lowercase(scope.$eval(attrs.ngModel))];
						}

						var count = 0;
						for (var i = 0; i < collection.length && count == 0; i++) {
							var matches = 0;
							for (var j = 0; j < myProperty.length; j++) {
								if (angular.lowercase(collection[i][myProperty[j]]) != '') {
									if (angular.lowercase(collection[i][myProperty[j]]) == angular.lowercase(model[j]) && collection[i][property] !== key && (!collection[i].Metadata || !collection[i].Metadata.IsDeleted)) {
										if (angular.lowercase(collection[i][myProperty[j]]) != null && model[j] != null) {
											matches++;
										}
									}
									if (matches == myProperty.length) {
										count++;
									}
								}
							}
						}

						if (count > 0) {
							console.log("unique violation for ", attrs.name);
							ngModel.$setValidity('unique', false);
							return viewValue;
						} else {
							ngModel.$setValidity('unique', true);
							return undefined;
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('customSort', [
		function () {
			return {
				restrict: 'A',
				transclude: true,
				scope: {
					orderby: '=',
					sort: '='
				},
				template:
					' <div ng-click="setOrder(orderby)" >' +
					'    <span ng-transclude></span>' +
					'    <span ng-class="selectedCls(orderby)" style="margin-left : 10px;"></span>' +
					'</div>',
				link: function (scope) {

					// change sorting order
					scope.setOrder = function (neworderby) {
						var sort = scope.sort;

						if (sort.orderby == neworderby) {
							sort.reverse = !sort.reverse;
						}
						sort.orderby = neworderby;
					};
					// change glyphicon
					scope.selectedCls = function (column) {
						if (column == scope.sort.orderby) {
							return ('glyphicon glyphicon-triangle-' + ((scope.sort.reverse) ? 'bottom' : 'top'));
						}
					};
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('compareTo', [
		function () {
			return {
				restrict: 'A',
				require: "ngModel",
				link: function (scope, elm, attr, ctrl) {
					var pwdWidget = elm.inheritedData('$formController')[attr.compareTo];

					ctrl.$parsers.push(function (value) {
						if (value === pwdWidget.$viewValue) {
							ctrl.$setValidity('match', true);
							return value;
						}

						if (value && pwdWidget.$viewValue) {
							ctrl.$setValidity('match', false);
						}

					});

					pwdWidget.$parsers.push(function (value) {
						if (value && ctrl.$viewValue) {
							ctrl.$setValidity('match', value === ctrl.$viewValue);
						}
						return value;
					});
				}

			};
		}
	]);

	angular.module('app.shared.directives').directive('customSortRight', [
		function () {
			return {
				restrict: 'A',
				transclude: true,
				scope: {
					orderby: '=',
					sort: '='
				},
				template:
					' <div ng-click="setOrder(orderby)" >' +
					'    <span ng-class="selectedCls(orderby)" style="margin-right : 10px;"></span>' +
					'    <span ng-transclude></span>' +
					'</div>',
				link: function (scope) {

					// change sorting order
					scope.setOrder = function (neworderby) {
						var sort = scope.sort;

						if (sort.orderby == neworderby) {
							sort.reverse = !sort.reverse;
						}
						sort.orderby = neworderby;
					};
					// change glyphicon
					scope.selectedCls = function (column) {
						if (column == scope.sort.orderby) {
							return ('glyphicon glyphicon-triangle-' + ((scope.sort.reverse) ? 'bottom' : 'top'));
						}
					};
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('customPopover', ['$compile', '$templateCache',
		function ($compile, $templateCache) {
			return {
				restrict: "A",
				link: function (scope, element, attrs) {
					var popoverContent;
					var contentType = scope.popoverType;
					popoverContent = $templateCache.get(attrs.popoverTemplate);

					var options = {
						trigger: 'click',
						content: $compile(popoverContent)(scope),
						placement: attrs.popoverPlacement,
						title: attrs.popoverTitle,
						html: true
					};
					$(element).popover(options);
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('showTab', [
		function () {
			return {
				restrict: 'EA',
				link: function (scope, element, attrs) {
					$(element).on('change', function (e) {
						e.preventDefault();
						$(this).tab('show');
					});

				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('currency', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = scope.$eval(attrs.ngModel);
						var symbol = attrs.currencysymbol;
						if (model != null && model != '') {
							if (model.substring(0, 1) != symbol) {
								ctrl.$setValidity('currency', false);
								return;
							}
							var dollarsAndCents = model.substring(1);
							var dollars = dollarsAndCents;
							var cents = "";
							var hasPeriod = false;
							for (var i = 0; i < dollarsAndCents.length; i++) {
								var character = dollarsAndCents.substring(i, i + 1);
								if (character != '.') {
									var characterToNum = parseInt(character);
									if (isNaN(characterToNum)) {
										ctrl.$setValidity('currency', false);
										return;
									}
								}
								if (character == '.') {
									if (hasPeriod == false) {
										dollars = dollarsAndCents.substring(0, i);
										cents = dollarsAndCents.substring(i + 1);
										hasPeriod = true;
									}
									else {
										ctrl.$setValidity('currency', false);
										return;
									}
								}
							}
							if (dollars.substring(0, 1) == 0 && dollars.length > 1) {
								ctrl.$setValidity('currency', false);
								return;
							}
							if (cents.length > 2) {
								ctrl.$setValidity('currency', false);
								return;
							}
						}
						ctrl.$setValidity('currency', true);
						return;
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('minconstraint', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = scope.$eval(attrs.ngModel);
						var max = attrs.maxvalue;
						if ((model != null && model != '' || model == 0) && max != null && max != '') {
							model = Number(model);
							if (model > max) {
								ctrl.$setValidity('minconstraint', false);
								return;
							}
						}
						ctrl.$setValidity('minconstraint', true);
						return;
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('maxconstraint', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = scope.$eval(attrs.ngModel);
						var min = attrs.minvalue;
						if ((model != null && model != '' || model == 0) && min != null && min != '') {
							model = Number(model);
							if (model < min) {
								ctrl.$setValidity('maxconstraint', false);
								return;
							}
						}
						ctrl.$setValidity('maxconstraint', true);
						return;
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('decimals', ['$filter',
		function ($filter) {
			return {
				restrict: "A",
				require: "?ngModel",
				scope: {
					decimals: "@",
					decimalPoint: "@"
				},
				link: function (scope, element, attr, ngModel) {
					var decimalCount = parseInt(scope.decimals) || 2;
					var decimalPoint = scope.decimalPoint || ".";

					// Run when the model is first rendered and when the model is changed from code
					ngModel.$render = function () {
						if (ngModel.$modelValue != null && ngModel.$modelValue >= 0) {
							if (typeof decimalCount === "number") {
								element.val(ngModel.$modelValue.toFixed(decimalCount).toString().replace(".", decimalPoint));
							} else {
								element.val(ngModel.$modelValue.toString().replace(".", decimalPoint));
							}
						}
					};

					// Run when the view value changes - after each keypress
					// The returned value is then written to the model
					ngModel.$parsers.unshift(function (newValue) {
						if (typeof decimalCount === "number") {
							var floatValue = parseFloat(newValue.replace(decimalPoint, "."));
							if (decimalCount === 0) {
								return parseInt(floatValue);
							}
							return parseFloat(floatValue.toFixed(decimalCount));
						}

						return parseFloat(newValue.replace(decimalPoint, "."));
					});

					// Formats the displayed value when the input field loses focus
					element.on("change", function (e) {
						var floatValue = parseFloat(element.val().replace(decimalPoint, "."));
						if (!isNaN(floatValue) && typeof decimalCount === "number") {
							if (decimalCount === 0) {
								element.val(parseInt(floatValue));
							} else {
								var strValue = floatValue.toFixed(decimalCount);
								element.val(strValue.replace(".", decimalPoint));
							}
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('selectRequired', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = angular.lowercase(scope.$eval(attrs.ngModel));
						if (model < 1 || model == null) {
							ctrl.$setValidity('selectRequired', false);
							return;
						} else {
							ctrl.$setValidity('selectRequired', true);
							return;
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('optionalSelectRequired', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = angular.lowercase(scope.$eval(attrs.ngModel));
						var required = scope.$eval(attrs.optionalSelectRequiredCheck);
						if ((model < 1 || model == null) && required) {
							ctrl.$setValidity('selectRequired', false);
							return;
						} else {
							ctrl.$setValidity('selectRequired', true);
							return;
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('horizontalScrollGrid', ['$timeout',
		function ($timeout) {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs) {
					scope.$watch(attrs.ngModel, function () {
						$timeout(function () {
							var outterHeight = '';
							var maxHeight = $(window).innerHeight() - 465;
							var outsideContainer = document.getElementById(attrs.outsideContainer);
							if (outsideContainer == null) return;
							if (elm[0].offsetHeight > (maxHeight - 40)) {
								elm.css('height', maxHeight + "px");
								outterHeight = maxHeight + 40;
								outsideContainer.style.height = outterHeight + "px";
								return;
							}
							elm.css('height', 'auto');
							outterHeight = elm[0].offsetHeight + 55;
							outsideContainer.style.height = outterHeight + "px";
							return;
						}, 0);
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('customFieldNumber', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = scope.$eval(attrs.ngModel);
						var min = attrs.minvalue;
						var max = attrs.maxvalue;
						var decimals = attrs.maxdecimals;
						if (decimals == null || decimals == '') {
							decimals = 4;
						}
						var hasPeriod = false;

						if (model != null && model != '') {
							for (var i = 0; i < model.length; i++) {
								var character = model.substring(i, i + 1);
								if (character != '.' && character != '-') {
									var characterToNum = parseInt(character);
									if (isNaN(characterToNum)) {
										ctrl.$setValidity('customFieldNumber', false);
										return;
									}
								}
								if (character == '.') {
									if (hasPeriod == false) { hasPeriod = true; }
									else {
										ctrl.$setValidity('customFieldNumber', false);
										return;
									}
								}
								if (character == '-' && i != 0) {
									ctrl.$setValidity('customFieldNumber', false);
									return;
								}
							}
							if (max != null && max != '') {
								if (parseFloat(model) > max) {
									ctrl.$setValidity('customFieldNumber', false);
									return;
								}
							}
							if (min != null && min != '') {
								if (parseFloat(model) < min) {
									ctrl.$setValidity('customFieldNumber', false);
									return;
								}
							}
							elm.bind('blur', function () {
								var value = ctrl.$modelValue;
								if (!value) return;
								value = value.toString();
								var formattedValue = Number(value).toFixed(decimals);
								if (!isNaN(formattedValue)) {
									ctrl.$setViewValue(formattedValue);
									ctrl.$render();
									return;
								}
								else {
									formattedValue = '';
									ctrl.$setViewValue(formattedValue);
									ctrl.$render();
									return;
								}
							});
						}

						ctrl.$setValidity('customFieldNumber', true);
						return;
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('alphaInput', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					scope.$watch(attrs.ngModel, function (viewValue) {
						var model = scope.$eval(attrs.ngModel);
						if (!/^[a-zA-Z]*$/g.test(model)) {
							ctrl.$setValidity('alphaInput', false);
							return;
						}
						else {
							ctrl.$setValidity('alphaInput', true);
							return;
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('onlyLettersInput', onlyLettersInput);
	// this different than other one - this doesnt allow at all instead of error field
	//https://stackoverflow.com/questions/28230080/directive-to-allow-only-alphabetic-characters-in-view-and-model-value
	function onlyLettersInput() {
		return {
			require: 'ngModel',
			link: function (scope, element, attr, ngModelCtrl) {
				function fromUser(text) {
					var transformedInput = text.replace(/[^a-zA-Z]/g, '');
					//console.log(transformedInput);
					if (transformedInput !== text) {
						ngModelCtrl.$setViewValue(transformedInput);
						ngModelCtrl.$render();
					}
					return transformedInput;
				}
				ngModelCtrl.$parsers.push(fromUser);
			}
		};
	};


	angular.module('app.shared.directives').directive('controlCodeCharGrid', ['$window',
		function ($window) {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs) {
					angular.element($window).bind('resize', function () {
						var width = $(window).innerWidth();
						var rows = scope.$eval(attrs.rows);
						var chars = angular.copy(scope.$eval(attrs.chars));
						if (width > 1001 && rows.length != 2) {
							rows.splice(0, rows.length);
							var firstRow = chars.splice(0, 18);
							var secondRow = chars;
							rows.push(firstRow, secondRow);
							scope.$digest();
							return;
						}
						if (width <= 1001 && width > 761 && rows.length != 3) {
							rows.splice(0, rows.length);
							var firstRow = chars.splice(0, 12);
							var secondRow = chars.splice(0, 12);
							var thirdRow = chars;
							rows.push(firstRow, secondRow, thirdRow);
							scope.$digest();
							return;
						}
						if (width <= 761 && rows.length != 4) {
							rows.splice(0, rows.length);
							var firstRow = chars.splice(0, 9);
							var secondRow = chars.splice(0, 9);
							var thirdRow = chars.splice(0, 9);
							var fourthRow = chars;
							rows.push(firstRow, secondRow, thirdRow, fourthRow);
							scope.$digest();
							return;
						}
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('fixedheight', ['$window',
		function ($window) {
			return {
				restrict: 'A',
				link: function (scope, elem, attrs) {
					var winHeight = $window.innerHeight;
					var headerHeight = attrs.fixedheight ? attrs.fixedheight : 0;
					var scale = attrs.scale ? attrs.scale : 1;
					elem.css('height', (winHeight - headerHeight) / scale + 'px');
				}
			};
		}
	]);

	// select and read  file
	angular.module('app.shared.directives').directive('asaSelectFile', ['$parse',
		function ($parse) {
			return {
				restrict: 'A',
				scope: false,
				link: function (scope, element, attr) {
					var fileType = attr['asaSelectFile'];
					var fn = $parse(attr.onReadFile);

					element.on('change', function (event) {
						var reader = new FileReader();
						reader.onload = function () {
							var fileContents = reader.result;
							scope.$apply(function () {
								fn(scope, { files: event.target.files, contents: fileContents, fileSize: element[0].files[0].size, lastFile: true });
								event.target.value = "";
							});
						};
						if (fileType === '' || fileType === 'text' || fileType === 'text-multiple') {
							if (fileType === 'text-multiple') {
								var customReader = new FileReader();

								var readCount = 0;
								var needReadCount = element[0].files.length;

								var combinedNames = "";
								var combinedContents = "";

								customReader.onload = function () {
									readCount++;
									var fileContents = customReader.result;
									if (needReadCount == readCount) {
										// last file
										combinedNames += element[0].files[readCount - 1].name;
										combinedContents += fileContents;

										scope.$apply(function () {
											fn(scope, { files: event.target.files, contents: combinedContents, combinedNames: combinedNames });
											event.target.value = "";
										});
									} else {
										combinedNames += element[0].files[readCount - 1].name + ", ";
										combinedContents += fileContents + "\n";
										customReader.readAsText(element[0].files[readCount]);
									}


								}
								customReader.readAsText(element[0].files[readCount]);

							} else {
								reader.readAsText(element[0].files[0]);
							}

						} else if (fileType === 'data') {
							reader.readAsDataURL(element[0].files[0]);
						}
						else if (fileType === 'rdx') {
							var fileExtPattern = /\.[0-9a-z]+$/i;
							var fileExt = (element[0].files[0].name.toUpperCase()).match(fileExtPattern);

							if (fileExt != ".RDX") {
								element[0].files[0].dos = true;
								reader.readAsText(element[0].files[0]);
							}
							else {
								reader.readAsDataURL(element[0].files[0]);
							}
						} else if (fileType === "excel") {
							reader.readAsBinaryString(element[0].files[0]);

						}
					});
				}
			};
		}
	]);

	// select and read  file
	angular.module('app.shared.directives').directive('asaDropUploadFile', ['$parse',
		function ($parse) {
			return {
				restrict: 'A',
				scope: false,
				link: function (scope, element, attr) {

					var fileType = attr['asaDropFile'];
					var fn = $parse(attr.onDropFile);

					var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes, files, iFileCount;

					processDragOverOrEnter = function (event) {
						if (event != null) {
							event.preventDefault();
						}
						event.dataTransfer = event.originalEvent.dataTransfer;
						event.dataTransfer.effectAllowed = 'copy';
						return false;
					};

					element.bind('dragover', processDragOverOrEnter);
					element.bind('dragenter', processDragOverOrEnter);


					return element.bind('drop', function (event) {

						var file, name, reader, size, type;
						if (event != null) {
							event.preventDefault();
						}

						reader = new FileReader();

						reader.onload = function () {

							var fileContents = reader.result;
							event.dataTransfer = event.originalEvent.dataTransfer;

							scope.$apply(function () {
								fn(scope, { files: files[iFileCount], contents: fileContents, lastFile: iFileCount == files.length - 1 ? true : false });
								event.target.value = "";
							});

						};

						reader.onloadend = function () {

							iFileCount++;
							if (iFileCount < files.length) {
								if (fileType === '' || fileType === 'text') {
									reader.readAsText(files[iFileCount]);
								} else if (fileType === 'data') {
									reader.readAsDataURL(files[iFileCount]);
								}
								else if (fileType === 'rdx') {
									var fileExtPattern = /\.[0-9a-z]+$/i;
									var fileExt = (files[iFileCount].name.toUpperCase()).match(fileExtPattern);

									if (fileExt != ".RDX") {
										files[iFileCount].dos = true;
										reader.readAsText(files[iFileCount]);
									}
									else {
										reader.readAsDataURL(files[iFileCount]);
									}
								}
							}

						};

						iFileCount = 0;
						event.dataTransfer = event.originalEvent.dataTransfer;
						files = event.dataTransfer.files;

						if (fileType === '' || fileType === 'text' || fileType === 'text-multiple') {
							if (fileType === 'text-multiple') {
								var customReader = new FileReader();

								var readCount = 0;
								var needReadCount = files.length;

								var combinedNames = "";
								var combinedContents = "";

								customReader.onload = function () {
									readCount++;
									var fileContents = customReader.result;
									if (needReadCount == readCount) {
										// last file
										combinedNames += files[readCount - 1].name;
										combinedContents += fileContents;

										scope.$apply(function () {
											fn(scope, { files: event.target.files, contents: combinedContents, combinedNames: combinedNames });
											event.target.value = "";
										});
									} else {
										combinedNames += files[readCount - 1].name + ", ";
										combinedContents += fileContents + "\n";
										customReader.readAsText(files[readCount]);
									}


								}
								customReader.readAsText(files[readCount]);

							} else {
								reader.readAsText(files[iFileCount]);
							}


						} else if (fileType === 'data') {
							reader.readAsDataURL(files[iFileCount]);
						}
						else if (fileType === 'rdx') {
							var fileExtPattern = /\.[0-9a-z]+$/i;
							var fileExt = (files[iFileCount].name.toUpperCase()).match(fileExtPattern);

							if (fileExt != ".RDX") {
								files[iFileCount].dos = true;
								reader.readAsText(files[iFileCount]);
							}
							else {
								reader.readAsDataURL(files[iFileCount]);
							}
						}

					});

				}

			};
		}
	]);

	angular.module('app.shared.directives').directive('stopParentScroll', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs) {
					$(elm).on('DOMMouseScroll mousewheel', function (ev) {
						var $this = $(this),
							scrollTop = this.scrollTop,
							scrollHeight = this.scrollHeight,
							height = $this.height(),
							delta = (ev.type == 'DOMMouseScroll' ?
								ev.originalEvent.detail * -40 :
								ev.originalEvent.wheelDelta),
							up = delta > 0;

						var prevent = function () {
							ev.stopPropagation();
							ev.preventDefault();
							ev.returnValue = false;
							return false;
						};

						if (!up && -delta > scrollHeight - height - scrollTop) {
							// Scrolling down, but this will take us past the bottom.
							$this.scrollTop(scrollHeight);
							return prevent();
						} else if (up && delta > scrollTop) {
							// Scrolling up, but this will take us past the top.
							$this.scrollTop(0);
							return prevent();
						}
					});
				}
			};
		}
	]);

    angular.module('app.shared.directives').directive('scrollCursorTrigger', [
        function () {
            return {
                restrict: 'A',
                link: function (scope, elm, attrs) {    
                    var mouseX;
                    var mouseY;

                    $(elm).on('mousemove', function (ev) {
                        mouseX = event.pageX;
                        mouseY = event.pageY;   
                    });
                    $(elm).on('DOMMouseScroll mousewheel', function (ev) {
                        if (mouseX != null) {
                            var el = document.elementFromPoint(mouseX, mouseY);
                            if (ev.originalEvent == null) {
                                var newval = $(elm).scrollTop() - ev.delta;
                                $(elm).scrollTop(newval);
                                return;
                            }
                            var delta;
                            if (ev.delta != null) {
                                delta = ev.delta;
                            } else {
                                delta = (ev.type == 'DOMMouseScroll' ?
                                    ev.originalEvent.detail * -40 :
                                    ev.originalEvent.wheelDelta);
                            }                           
                            // Create a new jQuery.Event object with specified event properties.
                            var e = jQuery.Event("DOMMouseScroll", { delta: delta});
                            
                            ev.stopPropagation();
                            ev.preventDefault();
                            ev.returnValue = false;
                          
                            jQuery(el).trigger(e);
                            return false;
                        }

                    });
                }
            }
        }
    ]);

	angular.module('app.shared.directives').directive('stopParentScrollCustom', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs) {
					var parentScroll = $("#gridWrapper");
					var parentLI = elm.closest("li");
					var lastScroll = null;

					$(elm).on('DOMMouseScroll mousewheel', function (ev) {
                        var $this = $(this),
                            scrollTop = this.scrollTop,
                            scrollHeight = this.scrollHeight,
                            height = $this.height();							
                           

                        var delta;

                        if (ev.delta != null) {
                            delta = ev.delta;
                        } else {
                            delta = (ev.type == 'DOMMouseScroll' ?
                                ev.originalEvent.detail * -40 :
                                ev.originalEvent.wheelDelta);
                        }

                        var up = delta > 0;
                        var alreadyMoved = false;
						var prevent = function () {
							ev.stopPropagation();
							ev.preventDefault();
                            ev.returnValue = false;
                            alreadyMoved = true;
							return false;
						};
                        
						if (parentScroll != null) {
							if (scrollHeight == height) { // No scroll bar on smaller element...
								console.log("special scroll")
								var parentScrollTop = parentScroll.scrollTop();
								parentScroll.scrollTop(parentScrollTop - delta);
								lastScroll = null;
								prevent();
                                alreadyMoved
							}


							if (up && parentLI.position().top + 10 < parentScroll.position().top) {
								// out of frame up
								console.log("special scroll")
								var parentScrollTop = parentScroll.scrollTop();
								parentScroll.scrollTop(parentScrollTop - delta * .5); // slow 
								lastScroll = null;
								prevent();
							}

							if (!up && parentLI.position().top > parentScroll.position().top + 15) { // out of frame down
								console.log("special scroll")
                                var parentScrollTop = parentScroll.scrollTop();

                                var snapVal = parentScrollTop - (parentScroll.position().top - parentLI.position().top);

								parentScroll.scrollTop(parentScrollTop - delta * .5); // slow 
								lastScroll = null;
                                prevent();
                                if ((parentLI.position().top > parentScroll.position().top + 15) == false) {
                                    // snap to top
                                    parentScroll.scrollTop(snapVal);
                                }
							}


						}


                        if (!up && -delta > scrollHeight - height - scrollTop) {
                            // Scrolling down, but this will take us past the bottom.
                            var alreadyAtBottom = lastScroll == scrollHeight;

                            $this.scrollTop(scrollHeight);
                            lastScroll = scrollHeight;
                            // at bottom
                            if (alreadyAtBottom && parentScroll != null) {
                                console.log("special scroll")
                                var parentScrollTop = parentScroll.scrollTop();
                                parentScroll.scrollTop(parentScrollTop - delta * .5); // slow 
                                prevent();
                            }

                            return prevent();
                        } else if (up && delta > scrollTop) {
                            // Scrolling up, but this will take us past the top.

                            var alreadyAtTop = lastScroll == 0;
                            lastScroll = 0;
                            $this.scrollTop(0);

                            if (alreadyAtTop && parentScroll != null) {
                                console.log("special scroll")
                                var parentScrollTop = parentScroll.scrollTop();
                                parentScroll.scrollTop(parentScrollTop - delta * .5); // slow 
                                prevent();
                            }

                            return prevent();
                        } else {
                            if (alreadyMoved!=true) {
                                var newval = $this.scrollTop() - delta;
                                $this.scrollTop(newval);
                                lastScroll = newval;
                                return prevent();
                            }
                        }
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaDatePicker', ['$window', '$parse', '$timeout', '$filter', '$locale', 'focus', '$rootScope',
		function ($window, $parse, $timeout, $filter, $locale, focus, $rootScope) {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					var model = $parse(attrs['ngModel']);
                    var showOnClick = scope.$eval(attrs.asaDatePickerShowOnClick);
                    var removeTime = scope.$eval(attrs.asaDatePickerRemoveTime);

					elm.bind('click', function () {
						if (showOnClick) { elm.datepicker("show"); }
					});

					ctrl.$parsers.push(function (value) {
						if (value == null || value == "") {
							value = null;
							ctrl.$setValidity('textDate', true);
						}
						else {
							value = dateValue(value);
							ctrl.$setValidity('textDate', true);
						}
						return value;
					});

					ctrl.$formatters.push(function (value) {
						return $filter('date')(value, shortDateWithFullYear());
					});



					$timeout(function () {
						elm.datepicker({
							dateFormat: getDateFormatString(true).toLowerCase(),
							showOn: "none",
							changeMonth: true,
							changeYear: true,
							maxDate: "+2y",
							monthNames: $locale.DATETIME_FORMATS.MONTH,
							dayNamesShort: $locale.DATETIME_FORMATS.SHORTDAY,
							dayNamesMin: $locale.DATETIME_FORMATS.SHORTDAY,
							dayNames: $locale.DATETIME_FORMATS.DAY,
							monthNamesShort: $locale.DATETIME_FORMATS.MONTH,
							firstDay: $locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 1,
							onSelect: function (date) {
                                var d = new Date(moment(date, getDateFormatString(), true));
                                var formattedDate = $filter('date')(d, shortDateWithFullYear());
								scope.$apply(function () {
									elm.val(formattedDate);
									ctrl.$setViewValue(formattedDate);
									focus(ctrl.$name);

									//NEED THIS FOR SHELL PAGE COMMUNICATION
									var dateObj = { ctrlName: ctrl.$name, newDate: formattedDate };
									$rootScope.$broadcast("datePickerUpdate", dateObj);

								});
							},
							beforeShow: function () { $timeout(function () { $("#ui-datepicker-div").css('z-index', 9999); }); }
						}).inputmask(getDateFormatForMask(), { clearIncomplete: true });
					});

					function dateValue(dateString) {
                        var momentObj = (moment(dateString, correctFormat(), true));
						// This isValid thing prevents it from triggering the change if the date is not complete
                        if (momentObj.isValid()) {
                            if (removeTime === true) { return momentObj.format("MM/DD/YYYY"); }
                            else { return new Date(momentObj); }
						}
						else { return null; }
					};

					//*getDateFormatString* which is the format that we are telling the JqueryDatePicker about
					function getDateFormatString(twoyear) {
						if (twoyear == null) twoyear = false;
						var retString = $locale.DATETIME_FORMATS.shortDate.toUpperCase();
						var delim = determinDelim(retString);
						var parts = retString.split(delim);
						for (var i = 0; i < parts.length; i++) {
							if (parts[i].indexOf("M") != -1) {
								parts[i] = "MM";
							}
							else if (parts[i].indexOf("D") != -1) {
								parts[i] = "DD";
							}
							else if (parts[i].indexOf("Y") != -1) {
								parts[i] = (twoyear ? "YY" : "YYYY");
							}
						}
						parts = parts.join(delim);
						return parts;
					};

					//*getDateFormatForMask* is for the input mask
					function getDateFormatForMask() {
						var mask = $locale.DATETIME_FORMATS.shortDate.toLowerCase();
						var delim = determinDelim(mask);
						var parts = mask.split(delim);
						var ret = "";
						for (var i = 0; i < parts.length; i++) {
							if (parts[i].indexOf("m") != -1) {
								parts[i] = "mm";
							}
							else if (parts[i].indexOf("d") != -1) {
								parts[i] = "dd";
							}
							else {
								parts[i] = "yyyy";
							}
						}
						return parts.join(delim);
					};

					//*shortDateWithFullYear* is for setting the date that we receive from the picker to a full year date
					function shortDateWithFullYear() {
						var ret = $locale.DATETIME_FORMATS.shortDate;
						if (ret.indexOf("yyyy") != -1 || ret.indexOf("YYYY") != -1) {
							return ret;
						}
						else {
							return ret.replace("yy", "yyyy");
						}
					};

					//*correctFormat* is for converting to the actual stored value
					function correctFormat() {
						var ret = $locale.DATETIME_FORMATS.shortDate;
						ret = ret.replace(/m/g, "M");
						ret = ret.replace(/d/g, "D");
						var delim = determinDelim(ret);
						var parts = ret.split(delim);
						for (var i = 0; i < parts.length; i++) {
							if (parts[i].indexOf("y") != -1) {
								parts[i] = "YYYY";
							}
							else if (parts[i].indexOf("D") != -1) {
								parts[i] = "D";
							}
							else if (parts[i].indexOf("M") != -1) {
								parts[i] = "M";
							}
						}
						ret = parts.join(delim);
						return ret;
					};

					function determinDelim(str) {
						if (str.indexOf("/") != -1) {
							return "/";
						}
						else if (str.indexOf("-") != -1) {
							return "-";
						}
						if (str.indexOf(".") != -1) {
							return ".";
						}
					};

					angular.element($window).bind("DOMMouseScroll mousewheel", function () {
						elm.datepicker("hide");
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaDatePickerButton', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs, ctrl) {
					elm.bind('click', function () {
						$(attrs.datepickerid).datepicker("show");
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaTimePicker', ['$filter', '$locale',
		function ($filter, $locale) {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {

					ctrl.$parsers.push(parse);

					function parse(value) {
						if (value == null || value == "") {
							value = null;
						} else {
							value = moment(value, ['h:m a', 'H:m']).format('HH:mm:ss');
						}
						return value;
					}


					ctrl.$formatters.push(format);

					function format(time) {
						if (time != null && time.length > 0) {
							var timePart = time.split("T");
							timePart = (timePart.length == 1 ? timePart[0] : timePart[1])
							var parts = timePart.split(':');
							var date = new Date(0, 0, 0, parts[0] || 0, parts[1] || 0, parts[2] || 0);
							return $filter('date')(date, 'shortTime');
						}
						return "";
					}



					$(function () {
						if ($locale.DATETIME_FORMATS.shortTime.indexOf("a") != -1) {
							elm.inputmask("hh:mm t", { clearIncomplete: false });

							/* having clearIncomplete: == false
	
							06:mm xm will be valid and just end up being 6:00 am
	
	
							*/
						} else {
							elm.inputmask("hh:mm", { clearIncomplete: false });
						}

						elm.blur(function () {
							var value = parse(ctrl.$viewValue);
							ctrl.$viewValue = format(value);
							ctrl.$render();
						})

					});
				}
			}
		}
    ]);

    
    angular.module('app.shared.directives').filter('asaTrunc', [
        function () {
            return function (num, dec) {
                //https://stackoverflow.com/questions/4912788/truncate-not-round-off-decimal-numbers-in-javascript
                var truncateDecimals = function (number, digits) {
                    var multiplier = Math.pow(10, digits),
                        adjustedNum = number * multiplier,
                        truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

                    return truncatedNum / multiplier;
                }; 
                if (num == null || dec == null) return num; 
                return truncateDecimals(num, dec)
            };
        }
    ]);


	angular.module('app.shared.directives').filter('formatTime', ['$filter',
		function ($filter) {
			return function (time, format) {
				if (time != null) {
					var timePart = time.split("T");
					timePart = (timePart.length == 1 ? timePart[0] : timePart[1]);
					var parts = timePart.split(':');
					var date = new Date(0, 0, 0, parts[0] || 0, parts[1] || 0, parts[2] || 0);
					return $filter('date')(date, format || 'shortTime');
				}
				return "";
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaCustomFieldDatePicker', ['$window',
		function ($window) {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ctrl) {
					$(function () {
						elm.datepicker({
							dateFormat: 'mm/dd/yy',
							showOn: "none",
							onSelect: function (date) {
								ctrl.$setViewValue(date);
							}
						}).inputmask("mm/dd/yyyy", { clearIncomplete: true });
					});
					angular.element($window).bind("DOMMouseScroll mousewheel", function () {
						elm.datepicker("hide");
						scope.$apply();
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaCustomFieldDatePickerButton', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs, ctrl) {
					elm.bind('click', function () {
						var nameString = "[name='" + attrs.datepickerid + "']";
						$(nameString).datepicker("show");
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaDisplayContactDetail', [
		function () {
			return {
				restrict: 'A',
				scope: {
					contact: '='
				},
				templateUrl: "/shared/directives/templates/contactDetail.html",
				controller: ['$scope', 'appGlobals', 'contactService', function ($scope, appGlobals, contactService) {
					$scope.showContactLine = function (cntctLine) {
						if (cntctLine == null || cntctLine == "") { return false; }
						return true;
					};

					$scope.routeForEmail = function (address) {
						appGlobals.ignoreRoute = true;
						window.location.href = "mailto:" + address;
					};

					$scope.getDispString = function () {
						if ($scope.contact != null) {
							return contactService.getContactDisplayString($scope.contact);
						}
						else {
							return "";
						}
					};
				}]
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaGridMaxlength', ['$timeout',
		function ($timeout) {
			return {
				restrict: 'A',
				link: function (scope, elm, attrs) {
					$timeout(function () {
						var maxlength = parseInt(attrs.asaGridMaxlength, 10);
						var inputs = angular.element(elm).find("input");
						angular.element(inputs[0]).attr('maxlength', maxlength);
					}, 0);
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('resetValidityOnChange', [
		function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, elm, attrs, ngModelCtrl) {
					ngModelCtrl.$viewChangeListeners.push(function () {
						ngModelCtrl.$setValidity(attrs.resetValidityOnChange, true);
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaElementFocusable', ['$timeout',
		function ($timeout) {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {

					var interval = setInterval(function () {
						if (element.is(':focusable')) {
							$timeout(function () {
								scope.$eval(attrs.asaElementFocusable);
							});
						}
					}, 500);

					scope.$on("$destroy", function () {
						clearInterval(interval);
					});
				}
			};
		}
	]);


	angular.module('app.shared.directives').directive('asaElementReady', ['$timeout',
		function ($timeout) {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					element.ready(function () {
						$timeout(function () {
							scope.$eval(attrs.asaElementReady);
						});
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaDocumentKeydown', ['$document', '$parse',
		function ($document, $parse) {
			return {
				restrict: 'A',
				compile: function ($element, attr) {
					var fn = $parse(attr['asaDocumentKeydown'], null, true);
					return function (scope, element) {
						$document.bind('keydown', function (event) {
							var callback = function () {
								fn(scope, { $event: event });
							};
							scope.$apply(callback);
						});

					};
				}
			};
		}
	]);

	// This directive is being used in the shell.html
	// it is for longpress and selecting drop down items.
	angular.module('app.shared.directives').directive('asaLongPressMenuToggle', ['$timeout', '$document',
		function ($timeout, $document) {
			return {
				restrict: 'E',
				scope: true,
				link: function ($scope, $elm, $attrs) {
					$scope.selectedIndex = -1;

					$elm.ready(function () {
						$elm.find('.dropdown-toggle').first().bind('mouseup', function (evt) {
							//evt.stopImmediatePropagation(); 19647
							//evt.preventDefault(); 19647
							$elm.children().first().toggleClass("open");
							$timeout(function () {
								if ($elm.children().first().hasClass("open")) {
									$document.bind('mouseup', onDocumentClick);
								}
							}, 1);
						});
					});

					function onDocumentClick() {
						$scope.selectedIndex = -1;
						$elm.children().first().removeClass("open");
						$document.unbind('mouseup', onDocumentClick);
					}

					$scope.actionListOver = function (index) {
						$scope.selectedIndex = index;
					};


				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('floatOnReady', [
		function () {
			return {
				restrict: "A",
				link: function ($scope, element, attrs) {
					$(element).ready(function () {
						$(element).floatThead({ autoReflow: true, scrollContainer: true });
					});
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaTouchStart', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					element.on('touchstart', doTouchstart);

					function doTouchstart(event) {
						//event.preventDefault();
						scope.$event = event;
						scope.$apply(attrs.asaTouchStart);
					}
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('asaTouchEnd', [
		function () {
			return {
				restrict: 'A',
				link: function (scope, element, attrs) {
					element.on('touchend', doTouchend);

					function doTouchend(event) {
						//event.preventDefault();

						// pass along the event object so its accessible in the action
						scope.$event = event;
						scope.$apply(attrs.asaTouchEnd);
					}
				}
			};
		}
	]);

	// allows you to pass in a function/expression that gets called when the user
	// clicks anywhere OUTSIDE of this element.  optionally, you can ignore clicks on 
	// elements with certain id's or classes.
	angular.module('app.shared.directives').directive('asaClickOutside', [
		function () {
			return {
				restrict: 'A',
				scope: {
					asaClickOutside: '&',
					ignoreId: "@",      // can use a space to specify multiple id's 
					ignoreClass: '@'    // or classes
				},
				link: function (scope, element, attrs) {
					var document = angular.element(element)[0].ownerDocument;

					angular.element(document).on('click', function (event) {
						if (shouldIgnoreTargetClick(event.target)) return; // ignore the click
						scope.asaClickOutside({ $event: event });
					});


					function shouldIgnoreTargetClick(targetElement) {
						// check if target is THIS element
						if (angular.element(element).is(angular.element(targetElement))) return true;

						// check if target is in the list of ignored id's
						if (scope.ignoreId != null && scope.ignoreId.length != 0) {
							var idArray = scope.ignoreId.split(" ");
							for (var i = 0; i < idArray.length; i++) {
								if (angular.element(targetElement).attr('id') == idArray[i]) return true;
							}
						}

						// check if target is in the list of ignored classes
						if (scope.ignoreClass != null && scope.ignoreClass.length != 0) {
							var classArray = scope.ignoreClass.split(" ");
							for (var i = 0; i < classArray.length; i++) {
								if (angular.element(targetElement).hasClass(classArray[i])) return true;
							}
						}

						return false;
					}
				}
			};
		}
	]);

	angular.module('app.shared.directives').directive('imageonload', function () {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				element.bind('load', function () {
					//call the function that was passed
					scope.$apply(attrs.imageonload);
				});
			}
		};
	});

	angular.module('app.shared.directives').directive('onTypeAheadReady', ['$parse', '$timeout', function ($parse, $timeout) {
		return {
			restrict: 'A',
			link: function ($scope, elem, attrs) {
				$timeout(function () {
					elem.ready(function () {
						$scope.$apply(function () {
							var func = $parse(attrs.onTypeAheadReady);
							func($scope);
						})
					})
				});
			}
		}
	}]);

	angular.module('app.shared.directives').directive('qtyInput', ['$parse', '$timeout', function ($parse, $timeout) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ngModel) {
				$timeout(function () {
					// Handle number of decimals
					ngModel.$parsers.unshift(function (viewValue) {
						if (viewValue != null && viewValue != "") {
							if (attrs.numofdecimals != null) {
								var valueStr = viewValue.toString();
								var decimalIdx = valueStr.indexOf(".");
								if (decimalIdx != -1) {
									var beforeDec = "";
									if (decimalIdx != 0) {
										beforeDec = valueStr.substring(0, decimalIdx);
										if (beforeDec.length >= 10) {
											beforeDec = angular.copy(beforeDec).substring(0, 10);
										}
									}
									var afterDec = valueStr.substring(decimalIdx + 1);
									if (afterDec.length > attrs.numofdecimals) {
										var newAfterDec = afterDec.substring(0, attrs.numofdecimals);
										var newViewValue = beforeDec + "." + newAfterDec;
										ngModel.$setViewValue(newViewValue);
										ngModel.$render();
										return newViewValue;
									}
									else {
										var newViewValue = beforeDec + "." + afterDec;
										ngModel.$setViewValue(newViewValue);
										ngModel.$render();
										return newViewValue;
									}
								}
								else {
									if (viewValue.length >= 10) {
										var newViewValue = valueStr.substring(0, 10);
										ngModel.$setViewValue(newViewValue);
										ngModel.$render();
										return newViewValue;
									}
									else { return viewValue; }
								}
							}
						}
						return viewValue;
					});
				});
			}
		};
	}]);

	angular.module('app.shared.directives').directive('currencyInput', ['$filter', function ($filter) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				function whatToSet(val) {
					if (!isNaN(val)) {
						var delim = ',';
						if (val == null || val == '') { return ''; }
						var initNum = (val !== null) ? val : 0;
						var numVal = (initNum !== undefined) ? initNum : 0;

						if (delim == ',') {
							var val = numVal.toString();
							val = val.replace(',', '.');
							numVal = parseFloat(val);
						}

						return numVal;
					}
				}

				function whatToShow(val) {
					var numOfDec = (attrs.numofdecimals == null) ? 4 : attrs.numofdecimals;
					return (!isNaN(val)) ? $filter('number')(val, numOfDec) : '';
				}

				ngModel.$parsers.push(whatToSet);
				ngModel.$formatters.push(whatToShow);

				ngModel.$parsers.unshift(function (viewValue) {
					if (viewValue != null && viewValue != "") {
						if (attrs.allownegative == "true") {
							var viewValueString = viewValue.toString();
							var negSignIdx = viewValueString.lastIndexOf("-");
							if (negSignIdx > 0) {
								var newViewValue = viewValueString.substring(0, negSignIdx);
								ngModel.$setViewValue(newViewValue);
								ngModel.$render();
								return newViewValue;
							}
						}
						if (attrs.numofdecimals && attrs.numofdecimals != "0") {
							var valueStr = viewValue.toString();
							var decimalIdx = valueStr.indexOf(".");
							if (decimalIdx != -1) {
								var beforeDec = "";
								if (decimalIdx != 0) {
									beforeDec = valueStr.substring(0, decimalIdx);
									if (beforeDec.length >= 7) {
										beforeDec = angular.copy(beforeDec).substring(0, 7);
									}
								}
								var afterDec = valueStr.substring(decimalIdx + 1);
								if (afterDec.includes(".")) {
									var newAfterDec = afterDec.substring(0, afterDec.indexOf("."));
									var newViewValue = beforeDec + "." + newAfterDec;
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return newViewValue;
								}
								else if (afterDec.length > attrs.numofdecimals) {
									var newAfterDec = afterDec.substring(0, attrs.numofdecimals);
									var newViewValue = beforeDec + "." + newAfterDec;
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return newViewValue;
								}
								else {
									var newViewValue = beforeDec + "." + afterDec;
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return newViewValue;
								}
							}
							else {
								if (viewValue.length >= 7) {
									var newViewValue = valueStr.substring(0, 7);
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return newViewValue;
								}
							}
						}
					}
					return viewValue;
				});

				element.bind("keypress", function (event) {
					if (event.keyCode != 9 && event.keyCode != 13 && event.keyCode != 27 && event.key != null) {
						var regexString = "^[0-9";
						if (attrs.allownegative == "true") { regexString += "-"; }
						if (attrs.numofdecimals && attrs.numofdecimals != "0") { regexString += "."; }
						regexString += "]$";
						var regex = new RegExp(regexString);
						if (!regex.test(event.key)) { event.preventDefault(); }
					}
				});

				element.bind('blur', function () {
					if (ngModel.$modelValue === undefined) { ngModel.$modelValue = null; }
					element.val(whatToShow(ngModel.$modelValue, attrs.numofdecimals))
				});

				element.bind('focus', function () {
					//element.val(ngModel.$modelValue);
					if ('selectAllOnFocus' in attrs) this.select();
				});
			}
		};
	}]);

	angular.module('app.shared.directives').directive('percentInput', ['$filter', function ($filter) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, ele, attr, ngModel) {
				ngModel.$parsers.unshift(function (viewValue) {
					if (viewValue != null && viewValue != "") {
						var numOfDec = 2;
						if (numOfDec != null) {
							var valueStr = viewValue.toString();
							var decimalIdx = valueStr.indexOf(".");
							if (decimalIdx != -1) {
								var beforeDec = "";
								if (decimalIdx != 0) {
									beforeDec = valueStr.substring(0, decimalIdx);
									if (beforeDec.length >= 7) {
										beforeDec = angular.copy(beforeDec).substring(0, 7);
									}
								}
								var afterDec = valueStr.substring(decimalIdx + 1);
								if (afterDec.length > numOfDec) {
									var newAfterDec = afterDec.substring(0, numOfDec);
									var newViewValue = beforeDec + "." + newAfterDec;
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return $filter('number')(parseFloat(newViewValue) / 100, 4);
								}
								else {
									var newViewValue = beforeDec + "." + afterDec;
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return $filter('number')(parseFloat(newViewValue) / 100, 4);
								}
							}
							else {
								if (viewValue.length >= 7) {
									var newViewValue = valueStr.substring(0, 7);
									ngModel.$setViewValue(newViewValue);
									ngModel.$render();
									return $filter('number')(parseFloat(newViewValue) / 100, 4);
								}
								else { return $filter('number')(parseFloat(viewValue) / 100, 4); }
							}
						}
					}
					return $filter('number')(parseFloat(viewValue) / 100, 4);
				});


				ngModel.$formatters.unshift(
					function (modelValue) {
						return $filter('number')(parseFloat(modelValue) * 100, 4);
					}
				);
			}
		}
	}]);

	angular.module('app.shared.directives').directive('asaEnterAsTab', function () {
		return function (scope, element, attrs) {
			element.bind("keydown keypress", function (event) {
				if (event.which === 13) {
					event.preventDefault();
					var fields = $(this).parents('form:eq(0),body').find("input[tabindex!='-1']:focusable,select[tabindex!='-1']:focusable,checkbox[tabindex!='-1']:focusable,radio[tabindex!='-1']:focusable,button[tabindex!='-1']:focusable");
					var index = fields.index(this);
					if (index > -1 && (index + 1) < fields.length)
						fields.eq(index + 1).focus();
				}
			});
		};
	});

	angular.module('app.shared.directives').directive('asaHomeKeyDuplicate', function ($parse, $rootScope) {

		return function (scope, element, attrs) {
			element.bind("keydown keypress", function (event) {
				if (event.which === 36) {
					event.preventDefault();
					console.log(attrs);
					$rootScope.$broadcast("asaHomeKeyDuplicate", event, event.which);
				}
			});
		}

	});

	//angular.module('app.shared.directives').directive('ngDropdownMultiselect', ['$filter', '$document', '$compile', '$parse',

	angular.module("app.shared.directives").directive("asaKeyup", ["$document", "$rootScope", function ($document, $rootScope) {
		return function () {
			$document.unbind("keyup");
			$document.bind("keyup", function (event) {
				$rootScope.$broadcast("asaKeyup", event, event.which);
			});
		};
	}]);

	angular.module('app.shared.directives').directive('asaMaskInput', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				mask: "@"
			},
			link: function (scope, element, attrs, ctrl) {
				var mask = scope.mask;
				element.inputmask(mask, {
					autoUnmask: true, clearMaskOnLostFocus: false, positionCaretOnClick: 'select'
				});
			}
		};
	});

	angular.module('app.shared.directives')
		.filter('levelGridFilter', function () {

			var _levelKeys = [];

			function getChildrenKeys(level) {
				_levelKeys.push(level.LevelKey);
				if (level.Children) {
					for (var i = 0; i < level.Children.length; i++) {
						getChildrenKeys(level.Children[i]);
					}
				}
			}

			return function (items, selectedLevel) {

				var filtered = [];

				if (!items) return;

				_levelKeys = [];

				if (selectedLevel) {
					_levelKeys.push(selectedLevel.LevelKey);

					if (selectedLevel.Children) {
						for (var i = 0; i < selectedLevel.Children.length; i++) {
							getChildrenKeys(selectedLevel.Children[i]);
						}
					}
				}

				for (var i = 0; i < items.length; i++) {
					var item = items[i];

					if (item.showRow == false) {
						item.isVisible = false;
						continue;
					}

					if (_levelKeys.indexOf(item.LevelKey) !== -1 || selectedLevel === null) {
						item.isVisible = true;
						filtered.push(item);
					} else {
						item.isVisible = false;
					}
				}

				return filtered;
			};
		});

	angular.module('app.shared.directives')
		.filter('modulePageFilter', function () {

			return function (items, moduleAppKey) {

				var filtered = [];

				if (!items) return;
 
				for (var i = 0; i < items.length; i++) {

					var item = items[i];

					if (moduleAppKey == 11) { //REPORTS

						if (item.ModulePage !== 'Reports' && item.ModulePage !== 'Dashboard') {
							item.Visible = true;
							filtered.push(item);
						}

					} else if (moduleAppKey == 1 || moduleAppKey == 2 || moduleAppKey == 5) {

						if (item.ModulePage !== 'Dashboard') {
							item.Visible = true;
							filtered.push(item);
						}

					} else {
						item.Visible = true;
						filtered.push(item);
					}

				}

				return filtered;

			};
		});
})();